import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83256742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-profile" }

import { 
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonItem,
  IonPage,
  IonTitle,
  IonToolbar,
  onIonViewDidEnter } from "@ionic/vue";
import { useStore } from "vuex";
import { translate } from "@/i18n";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onIonViewDidEnter(async() => {
  await fetchUserProfile()
})
const store = useStore()
const organizationDetails = computed(() => store.getters['user/getUserProfile']);


async function fetchUserProfile() {
  if (organizationDetails.value) return
  await store.dispatch('user/getProfile');
}

function logout() {
  store.dispatch('user/logout').then(() => {
    const redirectUrl = window.location.origin + '/login'
    window.location.href = redirectUrl
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Settings")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), { lines: "full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardHeader), { class: "ion-no-padding ion-padding-vertical" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardSubtitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(organizationDetails)?.username), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCardTitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(organizationDetails)?.userFullName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonButton), {
                  color: "danger",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Logout")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})